import { z } from 'zod'

import {
  emailField,
  nameField,
  passwordField,
  phoneNumberField,
} from '@maestro/commerce-blocks/schemas/fields'
import { m } from '@maestro/commerce-blocks/schemas/helpers'

export const registerCompanyInitiationSchema = z.object({
  organizationNumber: z
    .string()
    .transform((value) => value.replace(/\s/g, ''))
    .pipe(
      z
        .string()
        .regex(/^\d{9}$/, m('register-company.organization-number.invalid'))
    ),
})

export const registerCompanyDetailsSchema = z.object({
  firstName: nameField('first-name'),
  lastName: nameField('last-name'),
  phone: phoneNumberField,
  email: emailField,
  password: passwordField,
})
